// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import {
  getCSHReturnItemOlderDays,
  getIsCSHAppEnabled,
  getIsCSHEnabled,
  getBOSSOrderStatusEnabled,
  getIsCrossBrandMerchandisingEnabled,
  getIsBIAEnabledForOrderHistory,
  getOrderHistoryExtended,
  getNumberOfYears,
  getOrderHistoryExtendedPageSize,
  getAddPickUpPersonEnabled,
  getAltPersonLimit,
  getAltPersonInvalidOrderStatus,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import TrackOrderReducer from '@tcp/core/src/components/features/account/TrackOrder/container/TrackOrder.reducer';
import TrackOrderSaga from '@tcp/core/src/components/features/account/TrackOrder/container/TrackOrder.saga';
import OrdersSaga from '@tcp/core/src/components/features/account/Orders/container/Orders.saga';
import injectOrderDetailsDynamicStore from '@tcp/core/src/components/features/account/OrderDetails/container/OrderDetailsDynamicStore';
import OrdersReducer from './Orders.reducer';
import {
  getNewOrdersListItem,
  getOrderListFetchingState,
  getPreviewOrderId,
  getShowOrderListWithItemDetails,
  getUpcomingOrders,
  getLoadMoreState,
  getAccountOrdersAPISwitch,
  getOrdersLoader,
  getSelectedYear,
  getPagination,
  getFilterModalState,
  getCompanyId,
  getOrderFilterOptions,
  getOrderError,
} from './Orders.selectors';
import { setOrderResendModalOpen } from '../../../../common/organisms/ResendOrderConfirmation/container/ResendOrderConfirmation.actions';
import {
  getAllItems,
  getMostRecentOrders,
  getOrderDetailsDataFetchingState,
  getOrderLookUpAPISwitch,
} from '../../OrderDetails/container/OrderDetails.selectors';
import { getSiteId } from '../../../../../utils';
import OrderListComponent from '../views';
import {
  getOrdersList,
  setCompanyID,
  setFilterOptions,
  setPagination,
  setSelectedOrdersYear,
  toggleFilterModal,
  showLoadMore,
} from './Orders.actions';
import constants from '../Orders.constants';
import { getOrderDetails } from '../../OrderDetails/container/OrderDetails.actions';
import { buyItAgainProducts } from '../../BuyItAgain/container/BuyItAgain.selectors';
import { getBIAAvailProduct } from '../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.selectors';
import { getLocalStorage } from '../../../../../utils/localStorageManagement';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_ORDERS_LABEL,
  OrderDetailLabels,
  lblExtendedLast6Months,
} from '../../OrderDetails/container/OrderDetails.labels';
import {
  openForm,
  resetOrderPagination,
  setModalData,
} from '../../OrderDetails/organism/AddPickupPerson/container/AddPickUpPersonForm.actions';
import {
  getFormState,
  getResetOrderPageinationState,
} from '../../OrderDetails/organism/AddPickupPerson/container/AddPickUpPersonForm.selectors';

/**
 * This component will render OrdersContainer component
 * @param { object, Array }
 */
export class OrdersContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageNum: '0',
      showNewSkeleton: true,
    };
    this.loadMorePos = 0;
  }

  async componentDidMount() {
    await injectOrderDetailsDynamicStore();
    const {
      fetchOrders,
      previewOrderId,
      getOrderDetailsAction,
      showOrderListWithItemDetails,
      accountOrdersAPISwitch,
      orderLookUpAPISwitch,
      orderHistoryExtendedEnabled,
      companyId,
      setSelectedOrdersYearAction,
      setPaginationAction,
    } = this.props;
    const { pageNum } = this.state;
    let listPayload = getSiteId();
    if (showOrderListWithItemDetails) {
      listPayload = {
        reqParams: {
          itemdetails: true,
          pageNumber: pageNum,
          pageSize: constants.ORDER_SIZE,
        },
        accountOrdersAPISwitch,
      };
    }

    if (orderHistoryExtendedEnabled) {
      const currentYear = new Date().getFullYear();
      const lastSixMonths = new Date().setMonth(new Date().getMonth() - 6);
      const currentDate = new Date();
      const defaultYear = {
        year: currentYear,
        startDate: lastSixMonths ? new Date(lastSixMonths).toISOString() : '',
        endDate: currentDate ? new Date(currentDate).toISOString() : '',
        label: getLabelFromCopyOrFromTranslation(
          `${ACCOUNT_ORDERS_LABEL}.${lblExtendedLast6Months}`,
          OrderDetailLabels
        ),
        id: `${currentYear}_${0}`,
        pastOrder: false,
      };

      const localData = JSON.parse(getLocalStorage('ORDER_FILTER'));
      const yearObj = localData || defaultYear || {};
      setSelectedOrdersYearAction(yearObj);
      const listNewPayload = this.getExtendOrderPayload({
        yearObj,
        pageNum,
        accountOrdersAPISwitch,
        companyId,
      });
      if (yearObj?.pastOrder) {
        setPaginationAction(0);
        await fetchOrders(listNewPayload);
      } else {
        await fetchOrders(listPayload);
      }
    } else {
      await fetchOrders(listPayload);
    }
    if (!showOrderListWithItemDetails && previewOrderId) {
      const payload = {
        orderId: previewOrderId,
        isRecentOrder: true,
        orderLookUpAPISwitch,
      };
      getOrderDetailsAction(payload);
    }
  }

  async componentDidUpdate(prevProps) {
    await injectOrderDetailsDynamicStore();
    const {
      previewOrderId,
      getOrderDetailsAction,
      showOrderListWithItemDetails,
      orderLookUpAPISwitch,
    } = this.props;

    const prevPreviewOrderId = prevProps.previewOrderId;
    if (!showOrderListWithItemDetails && previewOrderId && prevPreviewOrderId !== previewOrderId) {
      const payload = {
        orderId: previewOrderId,
        orderLookUpAPISwitch,
      };
      getOrderDetailsAction(payload);
    }
  }

  getExtendOrderPayload = ({ yearObj, pageNum, accountOrdersAPISwitch, companyId }) => {
    const { startDate, endDate, pastOrder } = yearObj;

    return {
      reqParams: {
        itemdetails: true,
        pageNumber: pageNum,
        pageSize: constants.ORDER_SIZE,
        startDate: startDate ? new Date(startDate).toISOString() : '',
        endDate: endDate ? new Date(endDate).toISOString() : '',
        pastOrder,
      },
      fromLoadMore: true,
      fromDidMount: true,
      accountOrdersAPISwitch,
      currentSiteId: companyId || getSiteId(),
      siteId: getSiteId(),
    };
  };

  calculatePositionToScroll = () => {
    const loadMoreCta = document.querySelector('.load-more-cta');
    const showCondensedHeader = document.querySelector('.show-condensed-header');
    const { pageYOffset = 0 } = window || {};
    this.loadMorePos =
      (loadMoreCta && loadMoreCta.getBoundingClientRect().top) +
      pageYOffset -
      (showCondensedHeader && showCondensedHeader.getBoundingClientRect().height) -
      30;
  };

  /**
   * This function will fetch more orders data
   */
  loadMoreOrders = () => {
    const { fetchOrders, accountOrdersAPISwitch, companyId } = this.props;
    const { pageNum } = this.state;
    this.setState(
      {
        pageNum: Number(pageNum) + 1,
        showNewSkeleton: false,
      },
      () => {
        const { pageNum: pageNumUpdated } = this.state;
        fetchOrders({
          reqParams: {
            itemdetails: true,
            pageNumber: pageNumUpdated,
            pageSize: 5,
          },
          fromLoadMore: true,
          accountOrdersAPISwitch,
          currentSiteId: companyId || getSiteId(),
          siteId: getSiteId(),
        });
      }
    );
  };

  loadOrdersBasedOnFilter = async (selectedYear, payload) => {
    const {
      fetchOrders,
      accountOrdersAPISwitch,
      orderPagination,
      setPaginationAction,
      orderHistoryExtendedPageSize,
      companyId,
    } = this.props;
    const siteId = getSiteId();
    const { startDate, endDate, pastOrder } = selectedYear;
    const { fromPastLoadMore, fromDropDown } = payload;
    let pageNumber = 0;
    if (fromDropDown) {
      pageNumber = 0;
    } else if (fromPastLoadMore) {
      await setPaginationAction(Number(orderPagination) + 1);
      pageNumber = orderPagination + 1;
    } else {
      pageNumber = orderPagination;
    }
    fetchOrders({
      reqParams: {
        itemdetails: true,
        pageNumber,
        pageSize: Number(orderHistoryExtendedPageSize),
        startDate: startDate ? new Date(startDate).toISOString() : '',
        endDate: endDate ? new Date(endDate).toISOString() : '',
        pastOrder,
      },
      fromLoadMore: true,
      accountOrdersAPISwitch,
      fromDropDown,
      currentSiteId: companyId || getSiteId(),
      siteId,
    });
  };

  /**
   * This function will trigger the to get country specific orders
   * @param {string, string} - siteId companyId
   */
  filterLinkHandler = (siteId, companyId) => {
    const {
      fetchOrders,
      showOrderListWithItemDetails,
      accountOrdersAPISwitch,
      selectedYear,
      orderHistoryExtendedEnabled,
    } = this.props;
    let payload = { siteId, currentSiteId: companyId, accountOrdersAPISwitch };
    let payloadForExtendOrders = { siteId, currentSiteId: companyId, accountOrdersAPISwitch };
    if (showOrderListWithItemDetails) {
      payload = {
        ...payload,
        reqParams: {
          itemdetails: true,
          pageNumber: '0',
          pageSize: constants.ORDER_SIZE,
        },
      };

      this.setState({
        pageNum: '0',
      });
    }
    const { startDate, endDate, pastOrder } = selectedYear || {};

    if (orderHistoryExtendedEnabled && pastOrder) {
      payloadForExtendOrders = {
        ...payloadForExtendOrders,
        reqParams: {
          itemdetails: true,
          pageNumber: '0',
          pageSize: constants.ORDER_SIZE,
          startDate: startDate ? new Date(startDate).toISOString() : '',
          endDate: endDate ? new Date(endDate).toISOString() : '',
          pastOrder,
        },
        fromLoadMore: true,
        fromDidMount: true,
        fromDropDown: true,
        fromCountrySwitch: true,
      };

      fetchOrders(payloadForExtendOrders);
    } else {
      fetchOrders(payload);
    }
  };

  render() {
    const {
      ordersListItems,
      navigation,
      handleComponentChange,
      componentProps,
      orderItems,
      recentOrderDetails,
      isMostRecentOrderFetching,
      isMostRecentOrderDetailFetching,
      showOrderListWithItemDetails,
      upcomingOrders,
      isLoadMoreActive,
      cshReturnItemOlderDays,
      isCSHAppEnabled,
      setOrderResendModal,
      isCSHEnabled,
      isBOSSOrderStatusEnabled,
      isCrossBrandMerchandisingEnabled,
      isBIAEnabledForOrderHistory,
      biaProducts,
      route,
      isBIAAvailProduct,
      ordersLoader,
      setSelectedOrdersYearAction,
      selectedYear,
      setPaginationAction,
      orderHistoryExtendedEnabled,
      noOfPastYears,
      filterModalState,
      toggleFilterModalAction,
      setCompanyIDAction,
      companyId,
      setFilterOptionsAction,
      orderFilterOptions,
      isAddAltPickupPersonEnabled,
      altPickupPersonLimit,
      altPickupPersonInvaildOrderStatus,
      openFormAction,
      formState,
      setModalDataAction,
      isOrderError,
      setLoadMore,
    } = this.props;
    const { showNewSkeleton } = this.state;
    return (
      <OrderListComponent
        onFilterLink={this.filterLinkHandler}
        showOrderListWithItemDetails={showOrderListWithItemDetails}
        ordersListItems={ordersListItems}
        upcomingOrders={upcomingOrders}
        navigation={navigation}
        handleComponentChange={handleComponentChange}
        componentProps={componentProps}
        orderItems={orderItems}
        recentOrderDetails={recentOrderDetails}
        isMostRecentOrderFetching={isMostRecentOrderFetching}
        isMostRecentOrderDetailFetching={isMostRecentOrderDetailFetching}
        loadMoreOrders={this.loadMoreOrders}
        loadOrdersBasedOnFilter={this.loadOrdersBasedOnFilter}
        isLoadMoreActive={isLoadMoreActive}
        showNewSkeleton={showNewSkeleton}
        cshReturnItemOlderDays={cshReturnItemOlderDays}
        isCSHAppEnabled={isCSHAppEnabled}
        setOrderResendModalOpen={setOrderResendModal}
        isCSHEnabled={isCSHEnabled}
        isBOSSOrderStatusEnabled={isBOSSOrderStatusEnabled}
        isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
        isBIAEnabledForOrderHistory={isBIAEnabledForOrderHistory}
        biaProducts={biaProducts}
        route={route}
        isBIAAvailProduct={isBIAAvailProduct}
        ordersLoader={ordersLoader}
        selectedYear={selectedYear}
        setSelectedOrdersYearAction={setSelectedOrdersYearAction}
        setPaginationAction={setPaginationAction}
        orderHistoryExtendedEnabled={orderHistoryExtendedEnabled}
        noOfPastYears={noOfPastYears}
        filterModalState={filterModalState}
        toggleFilterModalAction={toggleFilterModalAction}
        setCompanyIDAction={setCompanyIDAction}
        companyId={companyId}
        orderFilterOptions={orderFilterOptions}
        setFilterOptionsAction={setFilterOptionsAction}
        isAddAltPickupPersonEnabled={isAddAltPickupPersonEnabled}
        altPickupPersonLimit={altPickupPersonLimit}
        altPickupPersonInvaildOrderStatus={altPickupPersonInvaildOrderStatus}
        openFormAction={openFormAction}
        setModalDataAction={setModalDataAction}
        formState={formState}
        isOrderError={isOrderError}
        setLoadMore={setLoadMore}
      />
    );
  }
}

export const mapStateToProps = (state, ownProps) => ({
  ordersListItems: getNewOrdersListItem(state),
  orderItems: getAllItems(state),
  recentOrderDetails: getMostRecentOrders(state),
  isMostRecentOrderFetching: getOrderListFetchingState(state),
  isMostRecentOrderDetailFetching: getOrderDetailsDataFetchingState(state),
  previewOrderId: getPreviewOrderId(state),
  showOrderListWithItemDetails: getShowOrderListWithItemDetails(state, ownProps),
  upcomingOrders: getUpcomingOrders(state),
  isLoadMoreActive: getLoadMoreState(state),
  accountOrdersAPISwitch: getAccountOrdersAPISwitch(state),
  orderLookUpAPISwitch: getOrderLookUpAPISwitch(state),
  cshReturnItemOlderDays: getCSHReturnItemOlderDays(state),
  isCSHAppEnabled: getIsCSHAppEnabled(state),
  isCSHEnabled: getIsCSHEnabled(state),
  isBOSSOrderStatusEnabled: getBOSSOrderStatusEnabled(state),
  isCrossBrandMerchandisingEnabled: getIsCrossBrandMerchandisingEnabled(state),
  isBIAEnabledForOrderHistory: getIsBIAEnabledForOrderHistory(state),
  biaProducts: buyItAgainProducts(state),
  isBIAAvailProduct: getBIAAvailProduct(state),
  ordersLoader: getOrdersLoader(state),
  selectedYear: getSelectedYear(state),
  orderPagination: getPagination(state),
  orderHistoryExtendedEnabled: getOrderHistoryExtended(state),
  noOfPastYears: getNumberOfYears(state),
  filterModalState: getFilterModalState(state),
  orderHistoryExtendedPageSize: getOrderHistoryExtendedPageSize(state),
  companyId: getCompanyId(state),
  orderFilterOptions: getOrderFilterOptions(state),
  isAddAltPickupPersonEnabled: getAddPickUpPersonEnabled(state),
  altPickupPersonLimit: getAltPersonLimit(state),
  altPickupPersonInvaildOrderStatus: getAltPersonInvalidOrderStatus(state),
  formState: getFormState(state),
  resetOrderPaginationState: getResetOrderPageinationState(state),
  isOrderError: getOrderError(state),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchOrders: (payload) => {
    dispatch(getOrdersList(payload));
  },
  setOrderResendModal: (payload) => {
    dispatch(setOrderResendModalOpen(payload));
  },
  trackAnalyticsClick: (eventData, payload) => {
    dispatch(setClickAnalyticsData(eventData));
    const timer = setTimeout(() => {
      dispatch(trackClick(payload));
      clearTimeout(timer);
    }, 100);
  },
  getOrderDetailsAction: (payload) => {
    dispatch(getOrderDetails(payload));
  },
  setSelectedOrdersYearAction: (payload) => {
    dispatch(setSelectedOrdersYear(payload));
  },
  setPaginationAction: (payload) => {
    dispatch(setPagination(payload));
  },
  toggleFilterModalAction: (payload) => {
    dispatch(toggleFilterModal(payload));
  },
  setCompanyIDAction: (payload) => {
    dispatch(setCompanyID(payload));
  },
  setFilterOptionsAction: (payload) => {
    dispatch(setFilterOptions(payload));
  },
  openFormAction: (payload) => {
    dispatch(openForm(payload));
  },
  setModalDataAction: (payload) => {
    dispatch(setModalData(payload));
  },
  resetOrderPaginationAction: (payload) => {
    dispatch(resetOrderPagination(payload));
  },
  setLoadMore: (payload) => {
    dispatch(showLoadMore(payload));
  },
});

OrdersContainer.propTypes = {
  fetchOrders: PropTypes.func,
  ordersListItems: PropTypes.shape([]),
  navigation: PropTypes.shape({}).isRequired,
  handleComponentChange: PropTypes.func,
  componentProps: PropTypes.shape({}),
  orderItems: PropTypes.shape([]),
  getOrderDetailsAction: PropTypes.func.isRequired,
  isMostRecentOrderFetching: PropTypes.bool,
  isMostRecentOrderDetailFetching: PropTypes.bool,
  previewOrderId: PropTypes.string,
  showOrderListWithItemDetails: PropTypes.bool,
  upcomingOrders: PropTypes.shape([]),
  isLoadMoreActive: PropTypes.bool,
  recentOrderDetails: PropTypes.shape([]),
  accountOrdersAPISwitch: PropTypes.bool,
  orderLookUpAPISwitch: PropTypes.bool,
  cshReturnItemOlderDays: PropTypes.shape({}),
  isCSHAppEnabled: PropTypes.bool,
  setOrderResendModal: PropTypes.func,
};

OrdersContainer.defaultProps = {
  fetchOrders: () => {},
  ordersListItems: [],
  recentOrderDetails: [],
  handleComponentChange: () => {},
  componentProps: {},
  orderItems: [],
  isMostRecentOrderFetching: false,
  isMostRecentOrderDetailFetching: false,
  previewOrderId: null,
  showOrderListWithItemDetails: false,
  upcomingOrders: [],
  isLoadMoreActive: false,
  accountOrdersAPISwitch: false,
  orderLookUpAPISwitch: false,
  cshReturnItemOlderDays: {},
  isCSHAppEnabled: false,
  setOrderResendModal: () => {},
};
const withReducer = withDynamicReducer(
  { key: 'Orders', reducer: OrdersReducer },
  { key: 'TrackOrderReducer', reducer: TrackOrderReducer }
);
const withSaga = useDynamicSaga(
  { key: 'OrdersSaga', saga: OrdersSaga },
  { key: 'TrackOrderSaga', saga: TrackOrderSaga }
);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(OrdersContainer);
